

































import { Component, Vue, Watch, Prop, Provide } from "vue-property-decorator";
@Component({
  components: {},
})
export default class extends Vue {}
